import axios from "axios";
import config from "../../config/config";
import Cookie from "cookies-js";

export const MS = {
    list,
    update,
    listMobile,
    updateMobile
};

function listMobile(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "manageService/listMobile?authorization=" + json_cookie.token).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function updateMobile(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manageService/updateMobile/?lang=th&authorization=" + json_cookie.token, data).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function list(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.get(config.API_URL + "manageService/list?authorization=" + json_cookie.token).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}

function update(data) {
    return new Promise((reslove, reject) => {
        let user_nbtc = Cookie.get('user_nbtc')
        let json_cookie = JSON.parse(user_nbtc);
        axios.post(config.API_URL + "manageService/update/?lang=th&authorization=" + json_cookie.token, data).then((res) => {
            reslove(res.data)
        }).catch((err) => {
            reject(err)
        })
    })
}